<template>
  <div class="color__exterior" >
    <carousel
      v-model="pri_image"
      :slides-per-view="1"
      :space-between="0"
      :pagination="{ clickable: true }"
      @slideChange="onSlideChange"
      @init="onInit"    
    >
      <slide
        v-for="primary_image in body_images"
        :key="primary_image"
        class="carousel__item"
        width="100%"
      >
        <img :src="primary_image" alt="primary_image" class="outer_img" />
      </slide>
    </carousel>
  </div>
</template>

<script>
import { props, context, inject, reactive, ref, toRefs, watch, onMounted } from "vue";
import SwiperCore, { Pagination, A11y } from "swiper";
import { Swiper as Carousel, SwiperSlide as Slide } from "swiper/vue";
// Import Swiper styles
import "swiper/swiper-bundle.css";
SwiperCore.use([Pagination, A11y]);

export default {
  emits: ['rewrite_angle'],
  components: {
    Carousel,
    Slide,
  },
  name: "ColorBodyImage",
  props: ["body_images", "pri_image", "current_angle","current"],

  setup(props,context) {
    const scrollHeader = ref(false);
    let swiper_component = ref(null);
    const onInit = (swiper) => {
      swiper_component = swiper;
    }
    const onSlideChange = (swiper) => {
      context.emit("selected_angle", swiper.activeIndex);
      // console.log(swiper.activeIndex + " onSlideChange");
    }

    const {current} = toRefs(props);
    const {current_angle} = toRefs(props);

    watch(current, () =>{
      // console.log(current_angle.value + " watch");
      // swiper_component.slides[1];
      swiper_component.slideTo(current_angle.value, 10);
      // const promise = new Promise((resolve, reject) => {
      // setTimeout(() => { 
      //   swiper_component.slideTo(current_angle.value, 1);
      //     resolve();
      //   }, 50);
      // });
      // promise.then(() => context.emit("update_angle", current_angle.value));

      });

    function showScrollTop() {
      if (window.matchMedia('(max-width:' + 560 + 'px)').matches) {
        if (window.scrollY >= 391) {
          scrollHeader.value = true;
        } else {
          scrollHeader.value = false;
        }
      }
    }
    onMounted(() => {
      window.addEventListener("scroll", showScrollTop, { passive: true });
    });
    return {
      scrollHeader,
      showScrollTop,
      onSlideChange,
      onInit,
    };
  },
};
</script>

<style scoped>
.fixed_menu {
position: fixed;
 background: #fff;
 top: 0;
 z-index: 999;
}
</style>
